<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
    <path
      d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976311 8.31658 0.292893 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM22 8V7H1V8V9H22V8Z"
      fill="url(#paint0_linear_5364_4195)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5364_4195"
        x1="1"
        y1="8"
        x2="1.096"
        y2="10.0022"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.456596" class="fill-1" />
        <stop offset="1" class="fill-2" />
      </linearGradient>
    </defs>
  </svg>
</template>

<style lang="scss" scoped>
.fill-1 {
  stop-color: #df252a;
}

.fill-2 {
  stop-color: #a20004;
}
</style>
